//src / components / Dashboard / PlayerDashboard / PlayerExtras / SigningInterest.jsx
// Player-side "On Watchlist" – VSN Transfers

import React, { useEffect, useState } from "react";
import { apiFetch } from "../../../../apiFetch";
import "./signingInterest.css";

const SigningInterest = () => {
  const [interests, setInterests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const playerId =
    typeof window !== "undefined"
      ? localStorage.getItem("playerId")
      : null;

  /* -----------------------------------------
     Fetch interests
  ------------------------------------------ */
  useEffect(() => {
    if (!playerId) {
      setError("Player ID not found. Please log in again.");
      setLoading(false);
      return;
    }

    let ignore = false;

    const fetchInterests = async () => {
      setLoading(true);
      setError("");

      try {
        const res = await apiFetch(`/api/player/${playerId}/interests`);



        if (!res.ok) {
          const text = await res.text().catch(() => "");
          throw new Error(
            `Failed to load interests (${res.status}): ${text}`
          );
        }

        const data = await res.json();

        if (!ignore) {
          setInterests(Array.isArray(data) ? data : []);
        }
      } catch (err) {
        console.error("❌ Failed to load player interests:", err);
        if (!ignore) {
          setError("Failed to load watchlist information.");
          setInterests([]);
        }
      } finally {
        if (!ignore) setLoading(false);
      }
    };

    fetchInterests();

    return () => {
      ignore = true;
    };
  }, [playerId]);

  /* -----------------------------------------
     Helpers
  ------------------------------------------ */
  const buildSenderMeta = (interest) => {
    const role =
      (interest.fromRole ||
        interest.senderRole ||
        interest.signedByRole ||
        "agent").toLowerCase();

    const name =
      interest.senderName ||
      interest.agentName ||
      interest.scoutName ||
      interest.clubName ||
      role.charAt(0).toUpperCase() + role.slice(1);

    let profilePath = null;

    const slug =
      interest.senderSlug ||
      interest.profileSlug ||
      interest.agentSlug ||
      interest.scoutSlug ||
      interest.clubSlug ||
      null;

    if (role === "agent" && slug) {
      profilePath = `/agent-profile/${slug}`;
    } else if (role === "scout" && slug) {
      profilePath = `/scout-profile/${slug}`;
    } else if (role === "club" && slug) {
      profilePath = `/club-profile/${slug}`;
    } else if (role === "agent" && interest.agentId) {
      // fallback if backend still sends only IDs
      profilePath = `/agent-profile/${interest.agentId}`;
    } else if (role === "scout" && interest.scoutId) {
      profilePath = `/scout-profile/${interest.scoutId}`;
    } else if (role === "club" && interest.clubId) {
      profilePath = `/club-profile/${interest.clubId}`;
    }



    return { role, name, profilePath };
  };

  /* -----------------------------------------
     Render
  ------------------------------------------ */
  return (
    <div className="signing-interest-container">
      <h2 className="player-interest-title">On Watchlist</h2>

      <p className="player-interest-subtitle">
        These agents, scouts, and clubs attempted to sign you and have shown
        interest in your profile.
      </p>

      {/* STATES */}
      {loading && (
        <p className="interest-empty">Loading watchlist…</p>
      )}

      {!loading && error && (
        <p className="interest-empty error">{error}</p>
      )}

      {!loading && !error && interests.length === 0 && (
        <p className="interest-empty">
          No agents, scouts, or clubs have shown interest yet.
        </p>
      )}

      {/* LIST */}
      {!loading &&
        !error &&
        interests.length > 0 &&
        interests.map((interest) => {
          const { role, name, profilePath } =
            buildSenderMeta(interest);

          const addedDate = interest.createdAt
            ? new Date(interest.createdAt).toLocaleDateString()
            : "—";

          return (
            <div
              key={interest.id}
              className="player-interest-card"
            >
              {/* HEADER */}
              <div className="player-interest-header">
                <span className="player-interest-role">
                  {role.toUpperCase()} INTEREST
                </span>
              </div>

              {/* CONTEXT */}
              <div className="player-interest-context">
                <span className="status-dot yellow" />
                {name} attempted to sign you while you were under contract.
              </div>

              {/* META */}
              <div className="player-interest-meta">
                <span className="player-interest-date">
                  Added on {addedDate}
                </span>
              </div>

              {/* ACTION */}
              {profilePath && (
                <div className="player-interest-actions">
                  <a
                    href={profilePath}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="player-interest-link"
                  >
                    View {role.charAt(0).toUpperCase() + role.slice(1)} Profile
                  </a>
                </div>
              )}
            </div>
          );
        })}
    </div>
  );
};

export default SigningInterest;








